import React, { useEffect, useState } from 'react';
import ApexCharts from 'apexcharts';
import api from 'api';

const StatisticsHourly = () => {
  const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split('T')[0]);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  // 시간대별 매출 데이터 조회
  const fetchHourlySales = async (date) => {
    setLoading(true);
    try {
      const response = await api.get(`/statistics/hourly?date=${date}`);
      setData(response);
    } catch (error) {
      console.error('시간대별 매출 조회 실패:', error);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchHourlySales(selectedDate);
  }, [selectedDate]);

  useEffect(() => {
    // ApexCharts 초기화
    if (data.length === 0) return;

    const options = {
      series: [
        {
          name: '판매액',
          data: data.map(d => Math.floor(d.sales / 100000)), // 단위: 만원
        },
        {
          name: '판매량',
          data: data.map(d => d.quantity),
        },
      ],
      chart: {
        type: 'bar',
        height: 350,
        toolbar: {
          show: true,
        },
      },
      colors: ['#4154f1', '#2eca6a'],
      dataLabels: {
        enabled: false,
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '60%',
          borderRadius: 4,
        },
      },
      stroke: {
        show: true,
        width: 2,
        colors: ['transparent'],
      },
      xaxis: {
        categories: data.map(d => `${d.hour}:00`),
      },
      yaxis: [
        {
          title: {
            text: '판매액 (만원)',
          },
        },
        {
          opposite: true,
          title: {
            text: '판매량',
          },
        },
      ],
      fill: {
        opacity: 1,
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return val;
          },
        },
      },
    };

    const chart = new ApexCharts(document.querySelector('#hourlyChart'), options);
    chart.render();

    return () => {
      chart.destroy();
    };
  }, [data]);

  const handleSearch = () => {
    fetchHourlySales(selectedDate);
  };

  return (
    <div className="row">
      <div className="card">
        <div className="card-body">
          <h5 className="card-title">시간대별 매출 현황 (10:00 ~ 22:00)</h5>

          <div className="row mb-3">
            <div className="col-sm-3">
              <label htmlFor="selectedDate" className="form-label">
                날짜 선택:
              </label>
              <input
                id="selectedDate"
                type="date"
                className="form-control"
                value={selectedDate}
                onChange={(e) => setSelectedDate(e.target.value)}
              />
            </div>
            <div className="col-sm-2" style={{ paddingTop: '35px' }}>
              <button type="button" className="btn btn-primary" onClick={handleSearch}>
                조회
              </button>
            </div>
            <div className="col-sm-7">&nbsp;</div>
          </div>

          {loading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">로딩 중...</span>
              </div>
            </div>
          ) : (
            <div id="hourlyChart"></div>
          )}

          <table className="table table-striped mt-4">
            <thead>
              <tr>
                <th scope="col">시간대</th>
                <th scope="col">판매액</th>
                <th scope="col">판매량</th>
                <th scope="col">고객수</th>
              </tr>
            </thead>
            <tbody>
              {data.map((item, index) => (
                <tr key={index}>
                  <td>
                    <strong>{item.hour}</strong>
                  </td>
                  <td>¥{item.sales.toLocaleString('ko-KR')}</td>
                  <td>{item.quantity}</td>
                  <td>{item.customers}</td>
                </tr>
              ))}
            </tbody>
          </table>

          <div className="alert alert-info mt-3" role="alert">
            <strong>주의:</strong> 본 통계는 매장 운영 시간인 10:00 ~ 22:00에 대한 시간대별 판매 현황을 보여줍니다.
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatisticsHourly;
